import { render, staticRenderFns } from "./ImageViewerComponent.vue?vue&type=template&id=5b60dbc2&scoped=true&"
import script from "./ImageViewerComponent.vue?vue&type=script&lang=js&"
export * from "./ImageViewerComponent.vue?vue&type=script&lang=js&"
import style0 from "./ImageViewerComponent.vue?vue&type=style&index=0&id=5b60dbc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b60dbc2",
  null
  
)

export default component.exports